export default function (values, types) {
    const errors = {};
    for (const key in types) {
        const type = types[key];
        const validator = validators[type.type];
        if (! validator) {
            console.error('No validator for type', type);

            if (type.params && type.params.required && ! values[key]) {
                errors[key] = 'required';
            }
            continue;
        }
        const error = validator(values[key], type.params || {});
        if (error) {
            errors[key] = error;
        }
    }
    
    return errors;
}


const validators = {
    select (value, params) {
        if (params.required) {
            if (! value) {
                return 'required';
            }
        }

        if (params.options && params.options.length && value) {
            if (! params.options.find(option => option.value === value)) {
                return 'invalid';
            }
        }
    },
    text (text, params) {
        const trimmed = (text || '').trim();
        if (params.required) {
            if (trimmed.length === 0) {
                return 'required';
            }
        }
        if (params.minLength && trimmed.length > 0 && trimmed.length < params.minLength) {
            return 'minLength';
        }
        if (params.maxLength && trimmed.length > params.maxLength) {
            return 'maxLength';
        }
    },
    textarea (text, params) {
        return validators.text(text, params);
    },
    email (email, params) {
        // TODO: validate email
        return validators.text(email, params);
    },
    rating (rating, params) {
        if (params.required) {
            if (!rating) {
                return 'required';
            }
        }
    },
    stringlist (strings, params) {
        if (params.required) {
            if (! strings || strings.length === 0) {
                return 'required';
            }
        }
        if (! strings) {
            return;
        }
        if (params.maxItems && strings.length > params.maxItems) {
            return 'maxItems';
        }
        for (const string of strings) {
            if (params.maxItemLength && string.length > params.maxItemLength) {
                return 'maxItemLength';
            }
        }
    },
    imagelist (images, params) {
        if (params.required) {
            if (!images || images.length === 0) {
                return 'required';
            }
        }
        if (! images) {
            return;
        }
        if (params.maxFiles && images.length > params.maxFiles) {
            return 'maxFiles';
        }
        
        let totalSize = 0;
        for (const file of images) {
            const size = file.file.size;
            if (params.maxSize && size > params.maxSize) {
                return 'maxSize';
            }
        }
        if (params.maxCombinedFileSize && totalSize > params.maxCombinedFileSize) {
            return 'maxCombinedFileSize';
        }
    },
    productlist (products, params) {
        if (params.required) {
            if (!products || products.length === 0) {
                return 'required';
            }
        }
        // @TODO
    },
};